<div
    *transloco="let t"
    class="bazis-control"
    [class]="'bazis-control ' + cssClassSizeControl"
    [ngClass]="{
        'bazis-control--focused': isFocused,
        'bazis-control--dirty': searchControl.dirty,
        'bazis-control--empty': emptyValues.indexOf(searchControl.value) > -1,
        'bazis-control--invalid': ngControl.control.invalid,
        'bazis-control--disabled': ngControl.control.disabled,
    }"
>
    <ng-container
        *ngIf="{
            required: required$ | async,
            list: list$ | async,
        } as data"
    >
        <bazis-label
            [isMajor]="hasTitleMajor"
            [isEmptyLabel]="isEmptyLabel"
            [title]="title || t(titleKey, titleParams)"
            [required]="data.required"
        >
            <bazis-interrogation
                *ngIf="tooltipKey"
                [slot]="tooltipSettings?.targetSide"
                iconSize="compact"
                [tooltipText]="t(tooltipKey, tooltipParams)"
                [tooltipOffset]="[-8, 4]"
                [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                [icon]="icons.interrogation"
                [type]="interrogationType"
            ></bazis-interrogation>
        </bazis-label>

        <div
            class="bazis-list_control-dd-wrapper"
            [class.bh-events-none]="isDisabled"
            clickOutside
            (clickOutside)="hideList()"
        >
            <bazis-input-default
                [formControl]="searchControl"
                [noteKey]="noteKey"
                [tooltipKey]="tooltipKey"
                [placeholderKey]="placeholderKey"
                [noteParams]="noteParams"
                [tooltipParams]="tooltipParams"
                [tooltipSettings]="tooltipSettings"
                [hasEraser]="hasEraser"
                [required$]="required$"
                [leftIcon]="leftIcon"
                [rightIcon]="rightIcon"
                [sizeControl]="sizeControl"
                (touched)="markAsTouched()"
                (focused)="isFocused = true; showList = true"
                (blured)="isFocused = false"
                (click)="toggleList()"
            >
                <bazis-form-error
                    *ngIf="searchControl.status !== 'INVALID'"
                    [formControl]="ngControl.control"
                    [validationErrorMessages]="validationErrorMessages"
                ></bazis-form-error>
                <ng-content></ng-content>
            </bazis-input-default>

            <bazis-list-hint
                *ngIf="data.list && data.list.length > 0 && showList && !isDisabled"
                [list]="data.list"
                [placeholderListKey]="placeholderListKey"
                (selected)="selectValue($event)"
            >
                <ng-template let-item="item">
                    {{ item.bin || item.inn }} ({{ item.name || item.name_ru }})
                </ng-template>
            </bazis-list-hint>
        </div>
    </ng-container>
</div>

<!-- DO NOT REMOVE -->
<ng-container *ngIf="searchValue$ | async"></ng-container>
